/* eslint-disable */
const config = {
  API_URL: (typeof window !== 'undefined' && window.location.origin) ? window.location.origin : '',
};

export default config;
